import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "w-full whitespace-pre" }
const _hoisted_2 = { class: "ml-2 text-sm text-muted" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  style: {"width":"1.95rem","height":"1.95rem"},
  class: "flex items-center rounded-full overflow-hidden p-1 bg-primary-light bg-opacity-20"
}
const _hoisted_5 = {
  style: {"stroke":"transparent","fill":"#6a16f0"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("title", null, "human-male-board", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", { d: "M20,17A2,2 0 0,0 22,15V4A2,2 0 0,0 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9A2,2 0 0,1 3.5,7H15M8,4A2,2 0 0,1 6,6A2,2 0 0,1 4,4A2,2 0 0,1 6,2A2,2 0 0,1 8,4Z" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_ProcessedTextFragment = _resolveComponent("ProcessedTextFragment")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_AbstractExercise = _resolveComponent("AbstractExercise")!

  return (_openBlock(), _createBlock(_component_AbstractExercise, _normalizeProps(_guardReactiveProps(_ctx.$props)), {
    submissionControls: _withCtx(() => [
      _createVNode(_component_TextEditor, {
        disabled: _ctx.readOnly,
        modelValue: _ctx.answerTextProxy,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.answerTextProxy) = $event)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("event_participation_slot.text_answer_label")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"])
    ]),
    readOnlyAnswer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("event_assessment.text_answer_label")), 1),
        (!_ctx.isAnswerTextParsedObject)
          ? (_openBlock(), _createBlock(_component_ProcessedTextFragment, {
              key: 0,
              style: {"white-space":"break-spaces"},
              class: "w-full px-4 py-2 rounded bg-gray-50",
              value: _ctx.answerTextProxy,
              defaultValue: _ctx.$t('misc.no_answer')
            }, null, 8, ["value", "defaultValue"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedAnswerText, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex items-center space-x-2"
                }, [
                  (item.role === 'user')
                    ? (_openBlock(), _createBlock(_component_Avatar, {
                        key: 0,
                        style: {"width":"1rem","height":"1rem"},
                        user: _ctx.metaStore.user
                      }, null, 8, ["user"]))
                    : _createCommentVNode("", true),
                  (item.role === 'assistant')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ProcessedTextFragment, {
                    style: {"white-space":"break-spaces"},
                    class: "w-full px-4 py-2 my-2 rounded bg-gray-50",
                    value: item.text,
                    defaultValue: _ctx.$t('misc.no_answer')
                  }, null, 8, ["value", "defaultValue"])
                ]))
              }), 128))
            ]))
      ])
    ]),
    _: 1
  }, 16))
}